import React__default from 'react';
import styles from '../9837bffb195015a4513e93472fb398acea449d84d98f6268afd87828b663e6c1.cfe-internal.js';
import '../../LoadingSpinner/8d55022eb7dc98c5cad52af9b09720070c60d56c43c0dee35584cf8912401ad4.cfe-internal.js';
import LoadingSpinner from '../../LoadingSpinner/b05dae0bfab7f74e168d22a1b9d6e2b06f09ee65c56c37161ee98465fe504ae4.cfe-internal.js';

var MenuSpinner = /*#__PURE__*/React__default.forwardRef(function (_, ref) {
  return /*#__PURE__*/React__default.createElement(LoadingSpinner, {
    ref: ref,
    className: styles.menuSpinner,
    show: true,
    size: "small",
    role: "menuitem"
  });
});

export { MenuSpinner as default };
